/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  getAddressEncoder,
  getProgramDerivedAddress,
  getU8Encoder,
  getUtf8Encoder,
  type Address,
  type ProgramDerivedAddress,
} from "@solana/kit";

export type RewardVaultSeeds = {
  /** The pool address */
  pool: Address;
  /** The reward index */
  rewardIndex: number;
};

/**
 * A reward vault account that holds reward tokens for distribution to liquidity providers.
 * Each pool can have multiple reward vaults indexed by rewardIndex (0-2).
 */
export async function findRewardVaultPda(
  seeds: RewardVaultSeeds,
  config: { programAddress?: Address | undefined } = {},
): Promise<ProgramDerivedAddress> {
  const {
    programAddress = "cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG" as Address<"cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG">,
  } = config;
  return await getProgramDerivedAddress({
    programAddress,
    seeds: [
      getUtf8Encoder().encode("reward_vault"),
      getAddressEncoder().encode(seeds.pool),
      getU8Encoder().encode(seeds.rewardIndex),
    ],
  });
}
